import React, { useEffect, useState } from 'react';

const PlantillaTest = () => {
  useEffect(() => {
    const scrollToHash = () => {
      const hash = window.location.hash;
      if (hash) {
        const id = hash.substring(1);
        const element = document.getElementById(id);
        
        if (element) {
          element.scrollIntoView({ 
            behavior: 'smooth',
            block: 'start'
          });
        }
      }
    };

    scrollToHash();
    const handleHashChange = () => {
      scrollToHash();
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  return (
    <>
    <section className="hero-section hero-4 bg-cover fix" style={{ backgroundImage: `url(/assets/kidsa/assets/img/hero/bottom.png)` }}>
      <div className="hero-content">
        <div className="row g-4 align-items-center">
            Modelo Educativo
          <div className="" data-wow-delay=".8s">
            <a></a>
          </div>
          <div className="col-lg-6">
         contenido modelo educativo
          </div>
          <div>
            <section id="nb2">
              <div>Modelo NB2</div><hr />
            </section>
            <section id="nb1">
              <div>Modelo NB1</div><hr />
            </section>
            <section id="pre">
              <div>Pre</div><hr />
            </section>
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default PlantillaTest;